function toggleDisabledButtons(container: Element, disabled: boolean) {
  container
    .querySelectorAll<HTMLButtonElement>(
      'button[data-automation=registerButton], button[data-automation=shopButton]'
    )
    .forEach(element => {
      element.disabled = disabled;
    });
}

/**
 * Update ui based on register switching
 */
export function updateRegisterUI(selectedRegisterID: string, isRegisterLocked: boolean) {
  // Use Array.prototype.forEach for IE support
  // https://developer.mozilla.org/en-US/docs/Web/API/NodeList#example
  Array.prototype.forEach.call(
    /**
     * Because of how retails tab work, it is possible to have multiple copy of the register ui hidden in the dom
     * To ensure the ui is consistent we need to update the dom of each instances.
     * In most case only one UI will be present but AFAIK we can have up to 3 instances (shop selection tab, register selection tab & sales page).
     */
    document.querySelectorAll('[data-automation="ui-tab-content"]'),
    (container: Element) => {
      // Disable/Enable all buttons depending on the register lock state
      toggleDisabledButtons(container, isRegisterLocked);

      // Move lock ui under the selected register
      const lockRootElement = container.querySelector('.lock_computer_container');
      const lockInputElement = container.querySelector<HTMLInputElement>('.lock_computer');
      const newRegisterButtonElement = container.querySelector<HTMLButtonElement>(
        `.registerButton_${selectedRegisterID}`
      );

      if (!lockInputElement || !lockRootElement || !newRegisterButtonElement) {
        // Can't find the required elements, this ui-tab-content doesn't have the register module
        return;
      }

      const oldRegisterButtonElements = container.querySelectorAll<HTMLButtonElement>(
        `button.current[data-automation=registerButton]`
      );
      const noRegisterSelected = oldRegisterButtonElements.length === 0;

      if (!noRegisterSelected) {
        oldRegisterButtonElements.forEach(function(item) {
          item.classList.remove('current');
        });
        // Remove selection style before we move the lock element
        lockRootElement.classList.remove('current');
        newRegisterButtonElement.classList.remove('current');
      }

      // Associate the lock ui with the new register
      lockRootElement.parentElement?.removeChild(lockRootElement);
      newRegisterButtonElement.parentElement?.appendChild(lockRootElement);
      lockInputElement.setAttribute('data-register-id', selectedRegisterID);

      // Ensure the checkbox reflect the lock state.
      if (lockInputElement.checked !== isRegisterLocked) {
        lockInputElement.checked = isRegisterLocked;
      }

      lockRootElement.classList.add('current');
      lockRootElement.classList.remove('hidden');
      newRegisterButtonElement.classList.add('current');

      // Prevent selecting a register when its already selected
      newRegisterButtonElement.disabled = true;

      // Update ui based on lock status change
      const lockLabel = container.querySelector<HTMLElement>('.lock_computer_label');
      if (lockLabel) {
        lockLabel.innerText = isRegisterLocked ? 'Locked' : 'Lock';
      }
    }
  );
}
